import { useEffect, useState } from "react";
import { FiChevronUp } from "react-icons/fi";
import styles from "./BackToTopButton.module.css";

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) {
    return null;
  }

  return (
    <button
      type="button"
      className={styles.button}
      onClick={goToTop}
      aria-label="Back to top"
    >
      <FiChevronUp className={styles.icon} />
    </button>
  );
};

export default BackToTopButton;
